import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { SERVICES } from "./data";
import { Container, MaskText, Reveal, Overline, ease } from "./primitives";

export const Services = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="servicos" className="bg-white py-20 lg:py-32" data-testid="services-section">
      <Container className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Overline>Serviços</Overline>
            <MaskText className="font-display mt-6 text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-5xl"
              lines={["Como posso ajudar", <>sua empresa a <span className="text-[#1238CE]">crescer.</span></>]} />
            <Reveal><p className="mt-6 max-w-sm text-base leading-relaxed text-slate-600">Um plano de ação detalhado, com processos claros e metas objetivas para garantir o crescimento da sua empresa.</p></Reveal>
          </div>
        </div>
        <div className="border-t border-slate-200 lg:col-span-7">
          {SERVICES.map((s, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={s.t} delay={i * 0.05} className="border-b border-slate-200">
                <button onClick={() => setOpen(isOpen ? -1 : i)} data-testid={`service-accordion-item-${i + 1}`}
                  className="group flex w-full items-center gap-5 py-7 text-left sm:gap-8">
                  <span className="font-mono-x text-xs text-slate-500">0{i + 1}</span>
                  <span className={`font-display flex-1 text-xl font-semibold tracking-[-0.02em] transition-colors duration-300 sm:text-2xl ${isOpen ? "text-[#1238CE]" : "text-[#0F172A] group-hover:text-[#1238CE]"}`}>{s.t}</span>
                  <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-full border transition-[transform,background-color,border-color] duration-500 ${isOpen ? "rotate-45 border-[#1238CE] bg-[#1238CE] text-white" : "border-slate-300 text-[#0F172A]"}`}>
                    <Plus size={18} />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.5, ease }} className="overflow-hidden">
                      <div className="pb-8 pl-9 sm:pl-14">
                        <p className="max-w-lg text-base leading-relaxed text-slate-600">{s.d}</p>
                        <div className="mt-5 flex flex-wrap gap-2">
                          {s.items.map((it) => <span key={it} className="rounded-full bg-[#F4F6FB] px-4 py-2 text-xs font-semibold text-[#0F172A]">{it}</span>)}
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
};
